export function isValidQueryString(query: string): boolean {
  try {
    new URLSearchParams(query)
    return true
  } catch {
    return false
  }
}

export function toQueryParameters<T extends {}>(obj: T) {
  return new URLSearchParams(obj).toString()
}

export function fromQueryParameters(str: string) {
  return new URLSearchParams(str)
}
